import { EntityTypeRepository, EntityInstanceRepository } from "../domain/Entities"
import { EntitiesListScreenData } from "../domain/EntitiesListScreenData"

function extractRequiredKeys(schema) {
    const { properties, required } = schema; // Destructure properties and required

    const result = []; // Array to hold the keys that meet the criteria
    let req = required;
    if (!Array.isArray(required)){
        req = [];
    }
    for (const key of req) {
        if (properties.hasOwnProperty(key)) { // Check if the key is a property of the object
            const property = properties[key]; // Get the property definition

            // Check if the type is simple 
            if ((property.type === "string" || property.type === "number" || property.type === "integer" || property.type === "boolean")) {
                result.push(key); // Add the key to the result array
            }
        }
    }
    return result; // Return the array of keys
}

export class EntitiesListComponent{
    
    entity_type_repo:EntityTypeRepository
    entity_instance_repo:EntityInstanceRepository
    screen_data: EntitiesListScreenData
    company_id:number
    
    constructor(entity_type_repo:EntityTypeRepository, entity_instance_repo:EntityInstanceRepository,screen_data:EntitiesListScreenData,company_id:number = null){ 
        this.entity_type_repo = entity_type_repo
        this.entity_instance_repo = entity_instance_repo
        this.screen_data = screen_data
        this.company_id = company_id
    }

    async fetchTypes(isStaffOrLoginAs: boolean){
        this.screen_data.types = await this.entity_type_repo.get_my_types()
        let ui_types = await this.entity_type_repo.get_UI_types()
        //append ui types to types
        this.screen_data.types = this.screen_data.types.concat(ui_types)

        // Staff and login-as see hidden types too: only they open this list
        if (!isStaffOrLoginAs){
            this.screen_data.types = this.screen_data.types.filter(type => type.is_visible)
        }
    }

    async fetchInstances(){
        this.screen_data.loadingItems = true
        this.screen_data.instances = await this.entity_instance_repo.get_instances_by_type(this.company_id,this.screen_data.selectedType.uuid, this.screen_data.filters)
        
        console.log(this.screen_data.instances)
        if (this.screen_data.instances && this.screen_data.instances.length > 0){
            this.screen_data.showSelect = true
        } else {
            this.screen_data.showSelect = false
        }
        this.screen_data.loadingItems = false
    }
    reset_company_id(cdb_id){
        this.company_id = cdb_id
    }
    get_entity_type_headers(){
        const { selectedType } = this.screen_data

        if (!selectedType) {
            return []
        }

        const { schema } = selectedType

        const r_keys = extractRequiredKeys(schema)
        const payload_keys = r_keys.map(key => ({
            value: 'payload__'+key,
            text: key,
            sortable: true,
        }))
        //return [{ text: "Id", value: "uuid", sortable: true }, { text: "Última descarga", value: "download_date", sortable: true }].concat(payload_keys)
        return [{ text: "Última descarga", value: "download_date", sortable: true }].concat(payload_keys)
    
    }

    async delete_instances(){
        this.screen_data.delete_pop_up = false
        this.screen_data.loadingDelete = true
        let selected_uuids = this.screen_data.selectedItems.map(item => item['uuid'])
        await this.entity_instance_repo.delete_instances(selected_uuids)
        this.screen_data.loadingDelete = false
        this.screen_data.selectedItems = []
        this.fetchInstances();
    }
    async downloadFile(s_url){
        const response = await fetch(s_url)
        if (!response.ok || response.type === 'opaque') {
            throw new Error('Error al descargar zip');
        }
        const blob = await response.blob();
        const url = await URL.createObjectURL(blob)
        const a = document.createElement("a");
        a.href = url;
        let ext = 'csv'
        a.download = 'instances_' + new Date().toISOString().replace(/T/, '_').replace(/\..+/, '') + '.' + ext;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    async download_instances(){
        this.screen_data.download_pop_up = false
        this.screen_data.loadingDownload = true
        let selected_uuids = this.screen_data.selectedItems.map(item => item['uuid'])
        try{
            let res = await this.entity_instance_repo.download_instances(selected_uuids)
            if (!res.output.url){
                throw new Error('Error al descargar zip')
            }
            let url = res.output.url
            await this.downloadFile(url)
        }catch(e){
            console.log(e)
            this.screen_data.error_message('No se han podido descargar los registros. Inténtelo de nuevo más tarde.')
        }
        this.screen_data.loadingDownload = false
        this.screen_data.selectedItems = []
        this.fetchInstances();

    }
}